import { Navigate, Route, Routes } from "react-router-dom";
import CustomerPortal from "@/pages/CustomerPortal";
import Privacy from "@/pages/Privacy";
import SignDocument from "@/pages/SignDocument";
import PaymentOptions from "@/pages/PaymentOptions";
import SocialLinks from "@/pages/SocialLinks";

/** Everything served on the customer address. The staff sign-in does not exist here:
 *  any other address simply lands on the customer's own invoices page. */
export const CustomerSite = () => (
  <Routes>
    <Route path="/invoices" element={<CustomerPortal />} />
    <Route path="/my-documents" element={<Navigate to="/invoices" replace />} />
    <Route path="/sign/:token" element={<SignDocument />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/payment-options/:branch" element={<PaymentOptions />} />
    <Route path="/follow/:branch" element={<SocialLinks />} />
    <Route path="*" element={<Navigate to="/invoices" replace />} />
  </Routes>
);
